import { PromptbookTab } from "@/features/Promptbooks/components/PromptbookTab/PromptbookTab";
import { Flex, Tab, TabList, TabPanel, TabPanels, Tabs } from "@chakra-ui/react";
import { useEffect } from "react";
import { Helmet } from "react-helmet";
import { useParams, useSearchParams } from "react-router-dom";
import { WorkspaceTitle } from "../components/WorkspaceTitle/WorkspaceTitle";
import { useWorkspaceById } from "../hooks/useWorkspaces";

export const WorkspacePage = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const { workspaceId } = useParams();
  const teamId = searchParams.get("team") || undefined;

  const { data: workspace } = useWorkspaceById(workspaceId as string);
  const workspaceName = workspace?.name || "";

  useEffect(() => {
    if (workspace?.teamId && teamId !== workspace?.teamId) {
      setSearchParams({
        team: workspace?.teamId as string,
      });
    }
  }, [teamId, workspace?.teamId]);

  return (
    <Flex direction="column" flex="1" paddingX="4" paddingY="5" paddingTop="3">
      <Helmet>
        <title>{workspaceName} - Prompt Studio</title>
      </Helmet>
      <WorkspaceTitle teamId={teamId} workspaceName={workspaceName} workspaceId={workspaceId as string} />
      <Flex direction="column" flex="1" gap="3" marginTop="spacing-lg">
        <Tabs isLazy defaultIndex={0}>
          <TabList>
            <Tab
              height="2.5rem"
              color="foreground.primary"
              fontWeight="medium"
              fontStyle="label/M/medium"
              onClick={() => {
                searchParams.set("tab", "promptbooks");
                setSearchParams(searchParams.toString());
              }}
            >
              Promptbooks
            </Tab>
          </TabList>
          <TabPanels>
            <TabPanel padding="0" paddingTop="spacing-lg">
              <PromptbookTab workspaceId={workspaceId as string} teamId={teamId} />
            </TabPanel>
          </TabPanels>
        </Tabs>
      </Flex>
    </Flex>
  );
};
